import { render, staticRenderFns } from "./LugarInteres.vue?vue&type=template&id=851e64d6&"
import script from "./LugarInteres.vue?vue&type=script&lang=ts&"
export * from "./LugarInteres.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('851e64d6', component.options)
    } else {
      api.reload('851e64d6', component.options)
    }
    module.hot.accept("./LugarInteres.vue?vue&type=template&id=851e64d6&", function () {
      api.rerender('851e64d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plataforma/LugarInteres.vue"
export default component.exports